import { render } from "./CourseraPage.vue?vue&type=template&id=527b9e80"
import script from "./CourseraPage.vue?vue&type=script&lang=js"
export * from "./CourseraPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__